import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  children: React.ReactNode;
  keyWord: string;
  onClickOk: () => void | Promise<void>;
  onClickCancel: () => void;
}

/**
 * 確認モーダル OK / キャンセル を選択させる
 * @param param0
 * @returns
 */
function ConfirmInputModal({ children, keyWord, onClickOk, onClickCancel }: Props) {
  const { t } = useTranslation();

  const [inputKeyWord, setInputKeyWord] = useState('');
  return (
    <Modal
      active
      additionalClassName="popupfr340"
      displayCloseButton={false}
      onClose={() => {
        /* do nothing */
      }}
    >
      <div>{children}</div>
      <div>
        <input type="text" value={inputKeyWord} onChange={(e) => setInputKeyWord(e.target.value)} />
      </div>
      <div className="mb0">
        <input
          type="button"
          className="red-button"
          value={t('OK').toString()}
          onClick={() => {
            // キーワードが一致していたら実行／不一致の場合キャンセルボタンクリックと同じ
            if (keyWord === inputKeyWord) {
              void onClickOk();
            } else {
              void onClickCancel();
            }
          }}
        />
        <input type="button" className="red-button ml10" value={t('キャンセル').toString()} onClick={onClickCancel} />
      </div>
    </Modal>
  );
}

export default ConfirmInputModal;
